import type { ComponentPropsWithoutRef, ReactNode } from "react";
import { classNames } from "@/react/helpers/twMergeWithCN";

export interface ThinSidebarProps extends ComponentPropsWithoutRef<"div"> {
  children: ReactNode;
  className?: string;
}

export const ThinSidebar = ({
  children,
  className,
  ...rest
}: ThinSidebarProps) => (
  <div
    className={classNames(
      "text-default bg-primary relative z-20 h-full p-4",
      className,
    )}
    {...rest}
  >
    {children}
  </div>
);
